module.exports = __webpack_public_path__ + "media/images/emblems/Lesboisblason-3c9fb8c1c9c6c80c15fd9e859cafa2f8.png";